/**
 * 서버 오류를 화면에 그릴 수 있는 '문자열' 하나로 바꾼다.
 *
 * 🔴 FastAPI 검증 실패(422)의 detail 은 문자열이 아니라 배열 `[{type, loc, msg, input}, …]` 이다.
 *    그걸 그대로 상태에 넣어 JSX 로 그리면 React #31(«Objects are not valid as a React child»)이 나
 *    화면이 통째로 오류 화면이 된다 → 여기서 반드시 문자열로 접는다.
 * 🔴 e.message 는 쓰지 않는다 — axios 의 영어 문구(«Request failed with status code 422»)가
 *    그대로 사용자에게 보인다. 네트워크 오류도 fallback 문구로 간다.
 */
const DEFAULT_FALLBACK = '요청에 실패했습니다.';

const text = (value) => (typeof value === 'string' && value.trim() ? value : '');

export function errorText(e, fallback = DEFAULT_FALLBACK) {
  const safeFallback = text(fallback) || DEFAULT_FALLBACK;
  const d = e?.response?.data?.detail;

  const direct = text(d);
  if (direct) return direct;

  if (Array.isArray(d)) {
    // 원소는 문자열이거나 {msg} 꼴이다. 쓸 수 있는 문구만 모아 ' / ' 로 잇는다.
    const joined = d
      .map((item) => text(item) || text(item?.msg))
      .filter(Boolean)
      .join(' / ');
    if (joined) return joined;
  } else if (d && typeof d === 'object') {
    const msg = text(d.msg);
    if (msg) return msg;
  }

  return safeFallback;
}

export default errorText;
